import App from "./App";
import ReactDOM from "react-dom/client";
import "./assets/scss/index.scss";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./store/auth-contex";
import { NotifyProvider } from "./helpers/notify_display/notify.tsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <AuthContextProvider>
            <NotifyProvider>
                <App />
            </NotifyProvider>
        </AuthContextProvider>
    </BrowserRouter>
);
